export enum typeTheme {
  dark,
  light
}
